import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import FileUpload from "../../../components/form/FileUpload";

export default function AdminAddAvatarPage() {
  const navigate = useNavigate();

   const [avatar, setAvatar] = useState<File | null>(null)
   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (e:  React.FormEvent<HTMLFormElement>) => {
    // call API to create category
    e.preventDefault();
    if(!avatar){
        alert(t('upload_image_required'));
        return;
    }
    const formData = new FormData();
    if(avatar){
        formData.append("image",avatar);
    }
    updateResource(`avatar`, formData,
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["avatars-by-admin"],
            navigateAfter: () => navigate("/admin/avatars"),
          });
  };

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <form onSubmit={(e)=>onSubmit(e)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_avatar" />
        <FileUpload
        file={avatar}
        setFile={setAvatar}
        label={""}
        addText={t("add_avatar")}
        shape="circle"
        size={128}
        />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
